import React, { useEffect, useState } from "react";
import "./styles.scss";
import {
  Button,
  JobCard,
  NewsGroup,
  TrendingNewsCard,
} from "../../../components";
import { useHistory, withRouter } from "react-router-dom";
// import { getNewsByCategoryPage } from "../../news/service/news.service";
// import { getCategoryById } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getLanguage } from "../../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import { getAllJobsCategory } from "../../CreateNewItem/CreateNewJob/service/jobs.service";
import { setJobCategoryList, setJobs } from "../../Jobs/redux/actions";
import { GetIconByName } from "../../../config/icon";

const categoryId = process.env.REACT_APP_CABINET_NEWS;
const pageCount = process.env.REACT_APP_P_COUNT;
const lan = getLanguage();

const Index = ({ newsList, news_id, title, is_jobs }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");
  const [jobCategory, setJobCategory] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);

  const { jobCategoryList, jobList } = useSelector(
    ({ jobsReducer }) => jobsReducer
  );

  const history = useHistory();
  const dispatch = useDispatch();

  const fetchCategories = async () => {
    const response = await getAllJobsCategory();
    if (response?.data) {
      setJobCategory(response.data);
      dispatch(setJobCategoryList(response.data));
    }
  };

  const fetchTagName = (id) => {
    const isExist = (jobCategoryList || jobCategory)?.find(
      (x) => x?.job_category_id === id
    );
    console.log({ isExist });
    return isExist?.jobs_category_name;
  };

  useEffect(() => {
    if (jobCategoryList?.length === 0 && jobCategory?.length === 0) {
      fetchCategories();
    }
  }, []);

  return (
    <>
      <NewsGroup
        data={{
          titleName: title ? title : "Related news",
          mainType: "noBoarder",
          type: "en",
          linkName: "",
        }}
        is_header={title ? true : false}
        // onClickViewNews={() => {
        //   props.history.push("/" + categoryId);
        //   props.setMenuName(categoryId);
        // }}
      >
        {!is_jobs && newsList?.length > 0 && (
          <div className={`${title ? "pl-2 pr-2" : ""}`}>
            {newsList
              .filter((item) => item.news_id !== news_id)
              .slice(0, visibleCount) //  show limited items
              .map((item, index) => {
                // Check if the item has updates
                const hasUpdates =
                  Array.isArray(item.updates) && item.updates.length > 0;

                // If updates exist, use the latest update (or modify as needed)
                const displayItem = hasUpdates
                  ? {
                      ...item,
                      ...item.updates[item.updates.length - 1],
                    }
                  : item;

                return (
                  <React.Fragment key={index}>
                    <TrendingNewsCard
                      data={{
                        isBorder: index + 1,
                        isTrendingNo: false,
                        // trendingNo: "",
                        trendingNo: false,
                        isDate: false,
                        img_url: displayItem?.images?.[0]?.url,
                        created_at: displayItem?.created_at,
                        header: displayItem?.title[lan],
                        content: displayItem?.content,
                        tagViews: displayItem?.views,
                        type: "related",
                      }}
                      onClick={() => {
                        const generatedSlug = displayItem?.title?.[lan]
                          ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                          ?.replace(/\//g, "")
                          ?.replace(/\s*-\s*/g, " ")
                          ?.trim()
                          .split(/\s+/)
                          .slice(0, 5)
                          .join("-")
                          .replace(/-+/g, "-");
                        history.push(
                          `/${generatedSlug}/${displayItem?.news_id}`
                        );
                      }}
                    />
                    {/*<NewsCard*/}
                    {/*    key={index}*/}
                    {/*    data={{*/}
                    {/*        type: "small",*/}
                    {/*        isBorder: true,*/}
                    {/*        isUpdate: hasUpdates,*/}
                    {/*    }}*/}
                    {/*    item={displayItem}*/}
                    {/*    onClick={() => {*/}
                    {/*        */}
                    {/*        history.push(`/${item?.news_id}`);*/}
                    {/*    }}*/}
                    {/*/>*/}
                  </React.Fragment>
                );
              })}

            {/* Fade-out effect (only when collapsed) */}
            {newsList.length > 4 && visibleCount < newsList.length && (
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "40px",
                  background:
                    "linear-gradient(to top, white, rgba(255,255,255,0))",
                }}
              />
            )}

            {/* Show More / Show Less Button */}
            {newsList.length > 4 && (
              <div
                className="loading-more"
                style={{ marginTop: "5px", marginBottom: "20px" }}
              >
                <Button
                  data={{
                    btnName:
                      visibleCount >= newsList.length
                        ? "Show Less"
                        : "Show More..",
                    buttonType: "black-border",
                    buttonSize: "xs",
                    isLoading: isLoading,
                    btnIcon: GetIconByName(
                      visibleCount >= newsList.length
                        ? "arrow-up"
                        : "arrow-down"
                    ),
                  }}
                  onClick={() => {
                    setVisibleCount((prev) => {
                      if (prev >= newsList.length) {
                        // Reset to first 4 and scroll to top smoothly
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        return 4;
                      }
                      return Math.min(prev + 4, newsList.length);
                    });
                  }}
                />
              </div>
            )}
          </div>
        )}
        {is_jobs && newsList?.length > 0 && (
          <>
            {newsList
              .filter((jobs) => jobs.job_id !== news_id)
              .map((jobs, index) => {
                return (
                  <React.Fragment key={index}>
                    <JobCard
                      data={{
                        imgUrl: jobs?.banner_img?.file_url || jobs?.banner_img,
                        titleEn: jobs?.job_title?.en,
                        titleSi: jobs?.job_title?.si,
                        closingDate: jobs?.closing_date,
                        organization: fetchTagName(jobs?.organization) || "",
                        type: jobs?.job_application_type,
                        views: jobs?.views || 0,
                        downloads: jobs?.downloads || 0,
                      }}
                      // isOpen={activeCard === jobs?.job_id}
                      onClickView={() => {
                        dispatch(setJobs(jobs));
                        if (jobs?.keywords) {
                          history.push(`/${jobs?.keywords}/${jobs?.job_id}`);
                        } else {
                          const generatedSlug = jobs.job_title?.["si"]
                            ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                            ?.replace(/\s*-\s*/g, " ")
                            ?.replace(/\s*–\s*/g, " ")
                            ?.trim()
                            .split(/\s+/)
                            .slice(0, 5)
                            .join("-")
                            .replace(/-+/g, "-");
                          history.push(`/${generatedSlug}/${jobs?.job_id}`);
                        }
                      }}
                    />
                  </React.Fragment>
                );
              })}
          </>
        )}
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
// export default Index;
